export function setupFormHandler() {
  document.addEventListener("DOMContentLoaded", function () {
    const form = document.querySelector(".directory .fndry-filters");

    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();

        // Get selected values from the directory filter drop-downs
        const department = document.getElementById("query-0-departments").value;
        const position = document.getElementById("query-0-positions").value;

        // Construct the new URL for the our-people page with the params from the drop-downs
        let newUrl = "https://dev-ctn-plus.pantheonsite.io/our-people/";
        let params = new URLSearchParams();

        if (department) {
          params.append("department", department);
        }

        if (position) {
          params.append("position", position);
        }

        // Append parameters to the URL
        newUrl += "?" + params.toString();

        // Redirect to the new URL
        window.location.href = newUrl;
      });
    }
  });
}
